!function(){"use strict";
customElements.get("product-sticky")||customElements.define("product-sticky",class extends HTMLElement{
  constructor(){
    super();
    this._apply=this._apply.bind(this);
  }
  connectedCallback(){
    setTimeout(()=>{
      this.content=this.querySelector('.product__content');
      this.images=this.querySelector('.product__images');
      this.grid=this.content&&this.content.parentElement;
      if(!this.content||!this.images||!this.grid) return;
      this._apply();
      window.addEventListener('resize',this._apply);
      if(window.ResizeObserver){
        this._ro=new ResizeObserver(this._apply);
        this._ro.observe(this.content);
        this._ro.observe(this.images);
      }
    });
  }
  _apply(){
    if(!this.content||!this.images||!this.grid) return;
    // Reset both columns and grid
    this.content.style.position='';
    this.content.style.top='';
    this.content.classList.remove('is-sticky');
    this.images.style.position='';
    this.images.style.top='';
    this.images.classList.remove('is-sticky');
    this.grid.style.minHeight='';

    if(window.innerWidth<750) return;

    const headerH=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height'))||0;
    const topOffset=headerH+20;
    const imagesH=this.images.offsetHeight;
    const contentH=this.content.offsetHeight;
    const vpH=window.innerHeight;

    // Content is ALWAYS sticky at the top
    this.content.classList.add('is-sticky');
    this.content.style.position='sticky';
    this.content.style.top=topOffset+'px';

    if(contentH>imagesH){
      // Images shorter than content — pin images at viewport bottom,
      // extend grid so both columns have sticky range
      this.images.classList.add('is-sticky');
      this.images.style.position='sticky';
      this.images.style.top=(vpH-imagesH)+'px';
      this.grid.style.minHeight=(contentH+imagesH-vpH+topOffset)+'px';
    }
  }
  disconnectedCallback(){
    window.removeEventListener('resize',this._apply);
    if(this._ro) this._ro.disconnect();
  }
})}();
